import React, { useState } from 'react';

interface LanguageSelectorProps {
  currentLanguage: string;
  onLanguageChange: (language: string) => void;
}

const languages = [
  { code: 'pt-br', flag: '/assets/flags/brazil.svg', name: 'Português' },
  { code: 'en', flag: '/assets/flags/usa.svg', name: 'English' },
  { code: 'es', flag: '/assets/flags/spain.svg', name: 'Español' }
];

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  currentLanguage,
  onLanguageChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];
  const otherLanguages = languages.filter(lang => lang.code !== currentLanguage);

  return (
    <div className="relative">
      <button
        className="flex items-center space-x-2 text-white bg-transparent hover:bg-white/10 px-3 py-1.5 rounded-md transition-all duration-300 focus:outline-none border border-transparent hover:border-white/20"
        onClick={() => setIsOpen(!isOpen)}
        title={currentLang.name}
      >
        <img src={currentLang.flag} alt={currentLang.name} className="w-5 h-auto rounded-sm shadow-sm" />
        <span className="text-[10px] text-gray-400 transform transition-transform duration-300" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</span>
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-[1001]" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-xl overflow-hidden min-w-[140px] z-[1002] border border-gray-100 animate-fade-in-up">
            {otherLanguages.map((lang) => (
              <button
                key={lang.code}
                className="flex items-center w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-none group"
                onClick={() => {
                  onLanguageChange(lang.code);
                  setIsOpen(false);
                }}
                title={lang.name}
              >
                <img src={lang.flag} alt={lang.name} className="w-5 h-auto rounded-sm shadow-sm mr-3 transition-all" />
                <span className="text-gray-700 font-medium text-sm group-hover:text-primary transition-colors">{lang.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;